import React from "react";

export function AdminSectionHeader({
    title,
    description,
    action,
    className = "",
    testId,
}) {
    return (
        <div
            data-testid={testId}
            className={`mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between ${className}`}
        >
            <div className="min-w-0">
                <h1 className="md-h2 text-md-text">{title}</h1>
                {description && (
                    <p className="mt-1 max-w-2xl text-sm text-md-text-2">{description}</p>
                )}
            </div>
            {action && <div className="shrink-0">{action}</div>}
        </div>
    );
}

export default AdminSectionHeader;
